export const load = () => ({
	title: 'Easy Home Insulation with Indow Window Inserts',
	h1: 'How to Insulate Your Home with Acrylic Window Inserts',
	description:
		'Learn how acrylic window inserts provide insulation, eliminate condensation and are easy to install. Enjoy a more comfortable, quiet, and efficient home.',
	showTitle: true,
});
